import { Sprite, Text, Texture } from 'pixi.js';
import AssetsManager from '../../gamma-engine/core/assets/AssetsManager';
import { Tweener } from '../../gamma-engine/core/tweener/engineTween';
import LayoutBuilder from '../../gamma-engine/core/utils/LayoutBuilder';
import AdjustableLayoutContainer from '../../gamma-engine/core/view/AdjustableLayoutContainer';
import LayoutElement from '../../gamma-engine/core/view/model/LayoutElement';
import { ScreenOrientation } from '../../gamma-engine/core/view/ScreenOrientation';
import { UpdateLayoutDescription } from '../../gamma-engine/core/view/UpdateLayoutDescription';

export default class IntroScreenVideo extends AdjustableLayoutContainer {

    private introVideo: Sprite;
    private skipText: Text;
    private orientation: ScreenOrientation;
    private videoWidth: number;
    private videoHeight: number;
    protected videoElement: HTMLVideoElement;

    constructor(screenOrintation: ScreenOrientation) {
        super(AssetsManager.layouts.get('intro-screen-video'));
        this.orientation = screenOrintation;
        LayoutBuilder.create(this.layout, this, (le: LayoutElement) => {
            return this.customClassElementCreate(le);
        });
        this.on('added', this.onAdded, this);
        this.on('removed', this.onRemoved, this);
        this.skipText.eventMode = 'dynamic';
        this.skipText.cursor = 'pointer';
    }

    public updateLayout(desc: UpdateLayoutDescription) {
        super.updateLayout(desc);
        const scaleX = desc.baseWidth / this.videoWidth;
        const scaleY = desc.baseHeight / this.videoHeight;
        const scale = Math.min(scaleX, scaleY);
        this.introVideo.scale.set(scale);
        const x = (desc.baseWidth - this.videoWidth * scale) / 2;
        const y = (desc.baseHeight - this.videoHeight * scale) / 2;

        this.introVideo.position.set(x, y);
        this.skipText.position.set(desc.baseWidth / 2, desc.baseHeight * 0.9);
    }
    protected getCanvasSize() {
        const container = document.getElementById('game');
        const gameCanvas = container.getElementsByTagName('canvas')[0];
        return { width: gameCanvas.width, height: gameCanvas.height };
    }

    private onRemoved(): void {
        this.removeChild(this.introVideo);
        Tweener.removeTweens(this);
        this.skipText.off('pointerup', this.stopVideo, this);
    }

    private customClassElementCreate(le: LayoutElement): unknown {
        let instance: unknown = null;
        // let btn: Button;
        switch (le.customClass) {
            case 'VideoElement':
                instance = this.createVideo();
                break;
        }

        return instance;
    }

    private onAdded(): void {
        this.skipText.once('pointerup', this.stopVideo, this);
        document.body.addEventListener('keydown', this.stopVideo.bind(this), { once: true });
    }

    private createVideo() {
        if (this.orientation === ScreenOrientation.HORIZONTAL) {
            this.videoElement = AssetsManager.videos.get('intro-video-desktop');
            this.videoWidth = 1920;
            this.videoHeight = 1080;
        } else {
            this.videoElement = AssetsManager.videos.get('intro-video-mobile');
            this.videoWidth = 1080;
            this.videoHeight = 1920;
        }
        this.videoElement.play();
        this.videoElement.loop = false;
        this.videoElement.onended = () => this.onIntroVideoComplete();
        const videoTexture = Texture.from(this.videoElement);
        const videoSprite = new Sprite(videoTexture);
        return videoSprite;
    }

    protected onIntroVideoComplete() {
        this.emit('video_Ended');
    }

    private stopVideo() {
        this.emit('video_Ended');
        this.videoElement.pause();
        this.videoElement.currentTime = 0;
    }
}
